const SWITCH_MENU = 'components/layout/sidebar/SWITCH_MENU';
const OPEN_MENU = 'components/layout/sidebar/OPEN_MENU';
const CLOSE_MENU = 'components/layout/sidebar/CLOSE_MENU';
const EXTEND_MENU = 'components/layout/sidebar/EXTEND_MENU';

const initialState = {
  isOpened: {
    P102_WM_REPORT: false,
    P104_API_INTEGRATION: false,
  },
  asideMenuOn: false,
  extendMenuOn: false,
};
export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SWITCH_MENU:
      const tmp = state.isOpened;
      tmp[action.name] = !tmp[action.name]
      return {...state, isOpened: tmp};
    case OPEN_MENU:
      return {...state, asideMenuOn: true};
    case CLOSE_MENU:
      return {...state, asideMenuOn: false};
    case EXTEND_MENU:
      return {...state, extendMenuOn: !state.extendMenuOn};
    default:
      return state;
  }
};

export function switchMenu(item) {
  return {
    type: SWITCH_MENU,
    name: item,
  };
}

export function openMenu() {
  return {
    type: OPEN_MENU,
  };
}

export function closeMenu() {
  return {
    type: CLOSE_MENU,
  };
}

export function extendMenu() {
  return {
    type: EXTEND_MENU,
  };
}
